import React from "react"
import { useDispatch } from "react-redux"
import { PlayCircleFill } from "react-bootstrap-icons"
import { prependAndPlay } from "../../stores/mediaPlayerSlice"
import styles from "./styles.module.css"

export interface HotListsPlaylistData {
  playlist_id: number
  name: string
  nada_path: string
  band_id: number
  band_name: string
  band_path: string
  score: number
  follower_count: number
  song_count: number
  songs: any[]
}

interface HotListsAttrs {
  playlistId: number | null
  playlist_name: string
  playlist_path: string | null
}

interface Props {
  playlist: HotListsPlaylistData
  rank: number
  hotListsAttrs: HotListsAttrs
}

const recordHotListsPageView = (postId: number) => {
  const csrf = (document.querySelector("meta[name=csrf-token]") as HTMLMetaElement)?.content
  fetch("/api/v1/referral_conversions", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(csrf ? { "X-CSRF-Token": csrf } : {}),
    },
    body: JSON.stringify({
      convertible_type: "Post",
      convertible_id: postId,
      conversion_type: "page_view",
    }),
  })
}

const HotListsPlaylist = ({ playlist, rank, hotListsAttrs }: Props) => {
  const dispatch = useDispatch()

  const onPlayClick = () => {
    dispatch(
      prependAndPlay(
        playlist.songs.map((song: any) => ({
          id: song.post_id,
          title: song.title,
          band_id: song.band_id,
          band_name: song.band_name,
          album_id: song.album_id,
          album_name: song.album_name,
          album_path: song.album_path,
          cover_image_small: song.cover_image_small,
          duration: song.duration,
          local_path: song.local_path,
          nada_path: song.nada_path,
          parent_path: song.nada_path,
          streaming_url: song.streaming_url,
          post_type: song.post_type,
          ...hotListsAttrs,
        })),
      ),
    )
  }

  return (
    <div className={styles.row}>
      <span className={styles.rank}>{rank}</span>
      <div className={styles.songInfo}>
        <a
          href={playlist.nada_path}
          className={styles.title}
          onClick={() => recordHotListsPageView(playlist.playlist_id)}
        >
          {playlist.name}
        </a>
        <a href={playlist.band_path} className={styles.artist}>
          {playlist.band_name}
        </a>
      </div>
      <button
        onClick={onPlayClick}
        aria-label={`Play ${playlist.name}`}
        className={styles.playButton}
      >
        <PlayCircleFill size={22} />
      </button>
    </div>
  )
}

export default HotListsPlaylist
